import { render, staticRenderFns } from "./CategoryStock.vue?vue&type=template&id=3d6a6146&scoped=true&"
import script from "./CategoryStock.vue?vue&type=script&lang=js&"
export * from "./CategoryStock.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStock.vue?vue&type=style&index=0&id=3d6a6146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a6146",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSkeletonLoader})
